import useSWRImmutable from 'swr/immutable';
import { CollectionProps, CollectionHookProps } from '~/types/collections';

export function useCollections(
  fallbackData?: CollectionProps,
): CollectionHookProps {
  const {
    data: collections,
    mutate,
    error,
  } = useSWRImmutable(
    '/api/smartcollections/personal/?include_deals=true',
    fallbackData ? { fallbackData } : undefined,
  );

  return { collections, mutate, error };
}
